import React, { PureComponent } from 'react';

class AllowanceListHeader extends PureComponent {

    render() {
        
        return (
        	<thead className="table-header">
	            <tr className="table-list-row row-header">
	            	<th className="table-list-col bold">
						折讓證明單號碼
						<div className="fix-row-header">折讓證明單號碼</div>
		            </th>
		            <th className="table-list-col bold">
						折讓證明單日期
						<div className="fix-row-header">折讓證明單日期</div>
		            </th>
		            <th className="table-list-col bold">
						折讓金額(含稅)
						<div className="fix-row-header">折讓金額(含稅)</div>
		            </th>
					<th className="table-list-col bold">
		            	發票開立日期
		            	<div className="fix-row-header">發票開立日期</div>
		            </th>					
		            <th className="table-list-col bold">
		            	發票號碼
		            	<div className="fix-row-header">發票號碼</div>
		            </th>
		            <th className="table-list-col bold">
		            	發票種類
		            	<div className="fix-row-header">發票種類</div>
		            </th>
		            <th className="table-list-col bold">
	                    買受人
	                    <div className="fix-row-header">買受人</div>
	                </th>
		            <th className="table-list-col bold">
	                    買受人統編
	                    <div className="fix-row-header">買受人統編</div>
	                </th>
		            <th className="table-list-col bold">
	                    狀態
	                    <div className="fix-row-header">狀態</div>
	                </th>

		            <th className="table-list-col center action bold"
                        style={{
                        width: '40px'
                    }}>
	                    操作
	                    <div className="fix-row-header">操作</div>
	                </th>

	            </tr>
	        </thead>
        );
    }
}

export default AllowanceListHeader;


// WEBPACK FOOTER //
// ./src/components/allowance/AllowanceListHeader.jsx